<template>
  <div>
    <div 
      v-if="showWarningMessage"
      class="eviction-banner custom-banner"
      style="width: 80%; margin: 40px auto 0;"
    >
      <v-icon 
        class="accent--text close-icon" 
        @click="showWarningMessage = false"
      >
        mdi-close
      </v-icon>
      <i class="icofont-exclamation-circle icofont-2x accent--text" />
      <div class="text-part">
        <h4 class="accent--text banner-title">
          YOUR NEXT STEPS
        </h4>
        <p class="ma-0 secondary--text">
          After you file, the court will send you a notification that includes the case number and hearing date. In the future, we’ll guide you all the way through to the end. For now, be sure to contact the court or seek legal counsel for any questions pertaining to your proceeding.
        </p>
      </div>
    </div>

    <div
      class="mx-auto secondary--text"
      style="width: 60%; margin-top: 40px"
    >
      <div class="custom-title pt-8 pb-4">
        {{ title }}
      </div>
      <div class="pb-6">
        Thank you for using FileEvictions. We’ll email you a copy of your invoice
        and pleadings for your records. Access them any time from your dashboard.
        While you’re here, <span
          style="color:#6A7FDB; cursor: pointer;"
          @click="$smoothScroll({ scrollTo: $refs.instructionsSection, duration: 1000, offset: -50, })"
        >scroll down</span> to access your pleadings and view
        instructions for filing the
        <div
          style="display: inline"
          v-html="docs"
        />.
      </div>
      <div style="padding-bottom: 40px">
        NOTE: <u>You</u> are responsible for filing with the court.
      </div>

      <div />
      <v-container
        fluid
        class="pa-0 mb-4"
      >
        <v-row
          no-gutters
          justify-center
        >
          <v-col cols="12">
            <v-container>
              <v-row>
                <div
                  class="order-detail-upper-bar align-center d-flex"
                  style="padding: 40px;"
                >
                  <v-col>
                    <v-row class="pt-0 pb-0">
                      <v-col class="pt-0 pb-0">
                        <span class="font-weight-medium info--text text-uppercase">ORDER</span>
                      </v-col>
                    </v-row>
                    <v-row class="pt-0 pb-0">
                      <v-col class="pt-0 pb-0">
                        {{ orderDetails.orderNumber }}
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row class="pt-0 pb-0">
                      <v-col class="pt-0 pb-0">
                        <span class="font-weight-medium info--text text-uppercase">DATE</span>
                      </v-col>
                    </v-row>
                    <v-row class="pt-0 pb-0">
                      <v-col class="pt-0 pb-0">
                        {{ getOrderDate }}
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row class="pt-0 pb-0">
                      <v-col class="pt-0 pb-0">
                        <span class="font-weight-medium info--text text-uppercase">PRINT INVOICE</span>
                      </v-col>
                    </v-row>
                    <v-row class="pt-0 pb-0 pl-10">
                      <v-col class="pt-0 pb-0">
                        <i
                          class="icofont-file-pdf icofont-lg accent2--text"
                          style="cursor: pointer"
                          @click="printInvoice"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </div>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
      
      <v-container
        fluid
        class="pa-0"
        style="height: 60px;"
      >
        <v-row
          no-gutters
          justify-center
        >
          <v-container>
            <v-row>
              <v-col cols="7">
                <span class="pl-8 font-weight-medium info--text text-uppercase">ITEM</span>
              </v-col>
              <v-col><span class="pl-8 font-weight-medium info--text text-uppercase">PRICE</span></v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
      <v-container
        v-for="(item, index) in items"
        :key="item.id"
        fluid
        class="pa-0 mb-4"
      >
        <v-row
          no-gutters
          justify-center
        >
          <v-col cols="12">
            <v-container>
              <v-row style="position: relative;">
                <div
                  class="elevated-bar align-center d-flex"
                  @click="toggleComplaintsAndSummons({ item, index })"
                >
                  <v-col cols="7">
                    <div class="text-left pl-8">
                      {{ item.title }}
                    </div>
                    <div
                      class="text-left pl-8 font-weight-light"
                      style="font-size: 20px;"
                    >
                      {{ currentProperty.streetAddress }}{{ getUnitNoString(currentProperty.unitNo) }}, {{ currentProperty.city }}, {{ currentProperty.state }} {{ currentProperty.zipcode }}
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <div class="text-left pl-8 primary--text">
                      ${{ item.cost }}
                    </div>
                  </v-col>
                  <v-col
                    style="height: 100%"
                    cols="3"
                    class="pa-0 d-flex justify-end"
                  >
                    <div
                      class="elevated-bar-btn d-flex align-center justify-center"
                    >
                      <v-icon
                        style="font-size: 75px; color: #93aebf"
                      >
                        mdi-menu-{{ item.opened ? "up" : "down" }}
                      </v-icon>
                    </div>
                  </v-col>
                </div>
              </v-row>
              <v-row
                v-if="item.opened"
                class="mt-4"
              >
                <v-col cols="7">
                  <div
                    class="text-left pl-8 font-weight-medium"
                    style="font-size: 26px"
                  >
                    Includes
                  </div>
                </v-col>
                <v-col cols="2">
                  <div
                    class="text-left pl-8 font-weight-medium"
                    style="font-size: 26px"
                  >
                    $0.00
                  </div>
                </v-col>
                <v-col cols="3">
                  <div
                    class="text-left pl-8 font-weight-medium info--text"
                    style="font-size: 26px"
                  >
                    —
                  </div>
                </v-col>
              </v-row>
              <div v-if="item.opened">
                <v-row
                  v-for="(complaintsAndSummon, complaintIndex) in complaintsAndSummons"
                  :key="complaintIndex"
                >
                  <v-col style="padding-top: 0; padding-bottom: 0;">
                    <div
                      class="text-left pl-8"
                      style="font-size: 22px"
                    >
                      {{ complaintsAndSummon }}
                    </div>
                  </v-col>
                </v-row>
              </div>

              <v-row
                v-if="item.opened"
                style="margin-top: 70px;"
              >
                <hr
                  class="ml-10"
                  style="width: 80%"
                >
              </v-row>

              <v-row
                v-if="item.opened"
                class="mt-4"
              >
                <v-col cols="7">
                  <div
                    class="text-left pl-8 font-weight-medium"
                    style="font-size: 26px"
                  >
                    Software
                  </div>
                </v-col>
                <v-col cols="5">
                  <div
                    class="text-left pl-8 font-weight-medium"
                    style="font-size: 26px"
                  >
                    $0.00
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>

      <v-container
        fluid
        class="pa-0 mb-4 mt-12"
      >
        <v-row
          justify-center
          style="width: 90%"
        >
          <v-col
            v-for="(totalPriceItem, index) in totalPriceItems"
            :key="index"
            cols="4"
          >
            <v-card
              elevation="0"
              class="order-detail-upper-bar d-flex justify-center align-center flex-column"
              :class="[ totalPriceItem.header_tag === 'Total' ? 'total-box-style' : '' ]"
            >
              <div>
                <div
                  :class="totalPriceItem.header_tag === 'Total' ? 'white--text' : 'grey--eviction-text'"
                  class="font-weight-medium text-uppercase"
                >
                  {{ totalPriceItem.header_tag }}
                </div>
                <div
                  :class="totalPriceItem.header_tag === 'Total' ? 'white--text' : 'price--text'"
                  class="font-weight-bold text-uppercase"
                  style="font-size: 26px; margin-top: 7px;"
                >
                  ${{ totalPriceItem.price }}
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <div
        ref="instructionsSection"
        class="custom-title pt-8 pb-10"
      >
        Instructions
      </div>

      <div class="d-flex pb-12">
        <div class="pr-8">
          <i
            :class="currentCase.filingPlan === 'E-FILE' ? 'icofont-cloud-download' : 'icofont-print'"
            class="icofont-2x info--text"
          />
        </div>
        <div>
          <div
            class="text-left font-weight-medium info--text text-uppercase pb-2"
          >
            {{ currentCase.filingPlan === 'E-FILE' ? 'Download' : 'Print' }}
          </div>
          <div v-if="currentCase.filingPlan === 'E-FILE'">
            Click to download the Cover Letter, <span class="font-weight-bold">Verified Complaint</span>,
            <span class="font-weight-bold">Tenant Summons</span>, and Filing Instructions.
          </div>
          <div v-else>
            Click to download and print the Cover Letter, <span class="font-weight-bold">Verified Complaint</span>,
            <span class="font-weight-bold">Tenant Summons</span>, and Filing Instructions.
          </div>
          <v-btn
            color="accent2"
            depressed
            class="white--text mt-4 px-12"
            rounded
            @click="printPleadingsDialog = true"
          >
            {{ currentCase.filingPlan === 'E-FILE' ? 'Download' : 'print' }}
          </v-btn>

          <v-dialog
            v-model="printPleadingsDialog"
            value="''"
            max-width="900"
          >
            <print-pleadings-dialog
              @close:dialog="printPleadingsDialog = false"
            />
          </v-dialog>
        </div>
      </div>

      <div class="d-flex pb-12">
        <div class="pr-8">
          <i class="icofont-bill-alt icofont-2x info--text" />
        </div>
        <div>
          <div
            class="text-left font-weight-medium info--text text-uppercase pb-2"
          >
            FILING FEE
          </div>
          <div v-if="currentCase.filingPlan === 'E-FILE'">
            Submit payment in the amount of <span class="font-weight-bold">${{ getCourtFee }}</span>. This includes $50.00 filing fee, $5.00 per defendant ({{ currentCase.tenants.length }}), and ${{ getMileageFee }} mileage fee.
            When submitting your pleadings via the electronic filing system, you'll be asked to enter the mileage fee. We've calculated it for you—the amount is <span class="font-weight-bold">${{ getMileageFee }}</span>.
          </div>
          <div v-else>
            Submit payment in the amount of <span class="font-weight-bold">${{ getCourtFee }}</span>. This includes $50.00 filing fee, $5.00 per defendant ({{ currentCase.tenants.length }}), and ${{ getMileageFee }} mileage fee.
            Checks and money orders should be payable to the <span class="font-weight-bold">Treasurer, State of New Jersey</span>.
          </div>
        </div>
      </div>

      <!-- Other Components here -->
      <EFile v-if="currentCase.filingPlan === 'E-FILE'" />
      <MailIn v-else-if="currentCase.filingPlan === 'MAIL IN'" />
      <InPerson v-else />

      <!--Section 8  -->
      <div
        v-if="currentCase.section8"
        class="d-flex pb-12"
      >
        <div class="pr-8">
          <i class="icofont-building-alt icofont-2x info--text" />
        </div>
        <div>
          <div
            class="text-left font-weight-medium info--text text-uppercase pb-2"
          >
            SECTION 8
          </div>
          <div class="pb-2">
            Mail a copy of the <span class="font-weight-bold">Verified Complaint</span> to the Public Housing Office.
          </div>
          <div class="font-weight-bold">
            {{ currentCase.section8 && currentCase.publicHousingOfficeSection8.housingAuthorityWebsite }}
          </div>
          <div>
            {{ currentCase.section8 && currentCase.publicHousingOfficeSection8.address }}
          </div>
        </div>
      </div>

      <!--Questions  -->
      <div
        class="d-flex"
        style="padding-bottom: 70px;"
      >
        <div class="pr-8">
          <i class="icofont-question-circle icofont-2x info--text" />
        </div>
        <div>
          <div
            class="text-left font-weight-medium info--text text-uppercase pb-2"
          >
            QUESTIONS
          </div>
          <div class="pb-4">
            For questions pertaining to filing, or issues concerning clerical errors on the form, contact:
          </div>
          <div>
            Special Civil Part
          </div>
          <div class="font-weight-bold">
            {{ mileage.courtAddress && mileage.courtAddress.county }} Country Courthouse
          </div>
          <div class="pb-12">
            {{ mileage.courtAddress && mileage.courtAddress.phone }}
          </div>
          <div class="pb-4">
            For questions pertaining to filing fee, contact:
          </div>
          <div>
            Treasury Department
          </div>
          <div class="font-weight-bold">
            {{ mileage.courtAddress && mileage.courtAddress.county }} County Courthouse
          </div>
          <div class="pb-12">
            {{ mileage.courtAddress && mileage.courtAddress.phone }}
          </div>  
        </div>
      </div>
    </div>

    <div
      class="mx-auto secondary--text"
      style="width: 85%;"
    >
      <v-container
        fluid
        class="container-order-details-redirect mt-5"
      >
        <v-row>
          <v-col>
            <div
              style="cursor: pointer"
              @click="$router.push({ name: 'vc-signature' })"
            >
              <span class="icofont-caret-left icofont-1x primary--text mr-2" /> <span class="font-weight-medium info--text text-uppercase">GO BACK</span>
            </div>
          </v-col>
          <v-spacer />
          <v-col>
            <div
              class="d-flex justify-end"
              style="cursor: pointer"
              @click="$router.push({ name: 'main' })"
            >
              <span class="font-weight-medium info--text text-uppercase">DASHBOARD</span> <span class="icofont-caret-right icofont-1x primary--text ml-2" />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>  
</template>

<script>
import EFile from '@/components/order-details-filing-types/EFile';
import InPerson from '@/components/order-details-filing-types/InPerson';
import MailIn from '@/components/order-details-filing-types/MailIn';
import PrintPleadingsDialog from '@/components/dialogs/PrintPleadingsDialog';
import PDFTemplateData from '@/mixins/pdf-template-data';

import { mapGetters } from 'vuex';
// eslint-disable-next-line
import { downloadPDF } from "@/utils";

export default {
  name: "OrderDetails",
  components: {
    PrintPleadingsDialog,
    EFile,
    InPerson,
    MailIn,
  },
  mixins: [PDFTemplateData],
  data() {
    return {
      showWarningMessage: true,
      printPleadingsDialog: false,
      open: "Full Eviction: Self-File",
      title: "Order Details",
      items: [],
      docs: "Verified Complaint and Tenant Summons",
      complaintsAndSummons: ['Verified Complaint', 'Landlord Verification', 'Tenant Summons', 'Cover Letters'],
      totalPriceItems: [
        {
          header_tag: 'Discount',
          price: '0.00',
        },
        {
          header_tag: 'Subtotal',
          price: '0.00',
        },
        {
          header_tag: 'Total',
          price: '0.00',
        }
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentCase: "eviction/currentCase",
      case: "eviction/currentCase",
      currentProperty: "property/currentProperty",
      courtInfo: "eviction/courtInfo",
      orderDetails: "eviction/orderDetails",
      client: "client",
      mileage: "eviction/mileage",
    }),
    direction() {
      return (name) => (name === this.open ? "up" : "down");
    },
    getOrderDate() {
      return this.$dayjs(this.orderDetails.created_at).format('MM/DD/YYYY');
    },
  },
  watch: {
    client(val) {
      if (val) {
        const caseId = this.$route.params.id;
        this.$store.dispatch('eviction/getOrderByCaseId', { caseId, logMessage: 'OrderDetails.vue at line 539' });
        this.$store.dispatch('eviction/loadCase', { caseId, logMessage: 'OrderDetails.vue at line 540' });
      }
    }
  },
  async mounted() {
    window.scrollTo(0, 0);

    const caseId = this.$route.params.id;
    await this.$store.dispatch('eviction/getOrderByCaseId', { caseId, logMessage: 'OrderDetails.vue at line 548' });
    await this.$store.dispatch('eviction/loadCase', { caseId, logMessage: 'OrderDetails.vue at line 549' });

    this.items = this.orderDetails.items.map((value) => {
      return {
        ...value,
        opened: false
      }
    })
  },
  methods: {
    toggleComplaintsAndSummons({ item, index }) {
      item.opened = !item.opened;
      this.$set(this.items, index, item);
    },
    findTemplateTypeOrderDetail() {
      // 1: full
      // 2: without section 8, but with e-file
      // 3: with section 8, but without e-file
      // 4: without section 8 and e-file
      if (!this.case.section8 && this.case.filingPlan === 'E-FILE') {
        return 2;
      }

      if (this.case.section8 && this.case.filingPlan !== 'E-FILE') {
        return 3;
      }

      if (!this.case.section8 && this.case.filingPlan !== 'E-FILE') {
        return 4;
      }

      return 1;
    },
    async printInvoice() {
      const courtAddressState = this.mileage.courtAddress;

      const courtAddress = {
        countyCourt: courtAddressState.county,
        streetAddressCourt: courtAddressState.street,
        cityCourt: courtAddressState.city,
        stateCourt: courtAddressState.state,
        zipcodeCourt: courtAddressState.zipcode,
        phoneCourt: courtAddressState.phone
      }

      const orderDetails = this.orderDetails.items
        .map(value => ({ ...value }))
        .map((value) => {
          const orderDetail = Object.assign({}, value);
          orderDetail.cost = `$${orderDetail.cost.toFixed(2)}`;
          orderDetail.propertyFullAddress = `${this.currentProperty.streetAddress}${this.getUnitNoString(this.currentProperty.unitNo)}, ${this.currentProperty.city}, ${this.currentProperty.state} ${this.currentProperty.zipcode}`;
          return orderDetail;
        });

      const data = {
        fileType: 'Order Details',
        templateName: 'order_details',
        templateFileTypeSubfolder: this.findTemplateTypeOrderDetail(),
        data: {
          orderNo: this.orderDetails.orderNumber,
          orderDetails,
          filingType: this.currentCase.filingPlan,
          tenantFullNames: this.currentCase.tenants.map(tenant => tenant.name.trim().toUpperCase()).join(", "),
          exportDate: this.$dayjs().format("MMMM D, YYYY"),
          orderDetailFullAddress: `${this.currentProperty.streetAddress}${this.getUnitNoString(this.currentProperty.unitNo)}, ${this.currentProperty.city}, ${this.currentProperty.state} ${this.currentProperty.zipcode}`,
          ownerName: this.currentProperty.deedNames.toUpperCase(),
          section8: this.currentCase.section8,
          housingAuthorityWebsiteSection8: this.currentCase.publicHousingOfficeSection8 ? this.currentCase.publicHousingOfficeSection8.housingAuthorityWebsite : null,
          housingAuthorityAddressSection8: this.currentCase.publicHousingOfficeSection8 ? this.currentCase.publicHousingOfficeSection8.address : null,
          ...courtAddress,
          ...this.currentProperty.contactInfo,
          ...await this.getTemplateData()
        }
      };

      const response = await this.$http.post(`${process.env.VUE_APP_URL}/api/order/create-case-pleading-pdf`, data);

      downloadPDF(response.data.fileName, response.data.fileData);
    }
  },
};
</script>

<style scoped>
.hamburger-utility-button {
  position: absolute;
  top: 50px;
  right: -50px;
}

.grey--eviction-text {
  color: #93AEBF;
}

.order-detail-upper-bar {
  background-color: #F0F5F6;
  border-radius: 10px;
  height: 136px;
  width: 100%;
}

.total-box-style {
  background: #4DCCC4 0% 0% no-repeat padding-box;
  box-shadow: 15px 15px 40px #0000001f !important;
}

.price--text {
  color: #53809D;
}

.container-order-details-redirect {
  margin-bottom: 40px;
  padding-left: 0;
  padding-right: 0;
}
</style>